import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function SystemInfo({ width = 14, height = 14, fill = '#949494' }: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox={'0 0 14 14'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99967 0.333496C3.31967 0.333496 0.333008 3.32016 0.333008 7.00016C0.333008 10.6802 3.31967 13.6668 6.99967 13.6668C10.6797 13.6668 13.6663 10.6802 13.6663 7.00016C13.6663 3.32016 10.6797 0.333496 6.99967 0.333496ZM6.99967 10.3335C6.63301 10.3335 6.33301 10.0335 6.33301 9.66683V7.00016C6.33301 6.6335 6.63301 6.3335 6.99967 6.3335C7.36634 6.3335 7.66634 6.6335 7.66634 7.00016V9.66683C7.66634 10.0335 7.36634 10.3335 6.99967 10.3335ZM7.66634 5.00016H6.33301V3.66683H7.66634V5.00016Z"
        fill={fill}
      />
    </Svg>
  );
}
